import {
  createFrontendModule,
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import HomeIcon from '@material-ui/icons/Home';
import { homeRouteRef } from './routeRef';
import { homeFrTranslation } from './translation';

/**
 * The home page, at the root of the app. The catalog index, which used to sit
 * there, is back on its default `/catalog` (the `page:catalog` entry of the
 * app-config files).
 *
 * A title and an icon so that the app's nav lists it — `AppNav` drops a page
 * lacking either — and the sidebar places it first (`nav.take('page:waadoo-
 * home')` in modules/nav/Sidebar.tsx). The title is French as it stands: the
 * French nav titles of `@waadoo/backstage-i18n` only translate the upstream
 * plugins' English ones, and an unknown title is shown as is.
 *
 * `noHeader`: the page paints its own header, with the greeting.
 */
const homePage = PageBlueprint.make({
  params: {
    path: '/',
    title: 'Accueil',
    icon: <HomeIcon fontSize="inherit" />,
    routeRef: homeRouteRef,
    noHeader: true,
    loader: async () => {
      const { HomePage } = await import('./HomePage');
      return <HomePage />;
    },
  },
});

/** Registered in packages/app/src/App.tsx, with the translation module. */
export const homePlugin = createFrontendPlugin({
  pluginId: 'waadoo-home',
  extensions: [homePage],
});

// On the `app` plugin, like every TranslationBlueprint here: an extension of
// that kind created under any other pluginId is ignored without a word — see
// components/projectEnvironments/plugin.tsx.
export const homeTranslationModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homeFrTranslation],
});

export default homePlugin;
